module.exports = __webpack_public_path__ + "img/03mazda-hatchback.e9e4a8dc.png";